import React, {useMemo} from 'react';

import Event from './event';
import {cmpByKey} from '../utils/cmp';

export default function Events({
	isExpanded,
	feature,
	events,
	eventPredicates,
	tags,
}) {
	const containerClassName = isExpanded
		? 'bsknacht17-event-grid'
		: 'bsknacht17-event-list';
	const itemClassName = containerClassName + '__item';
	const prefixClassName = (element) => itemClassName + '__' + element;

	const sortedEvents = useMemo(
		() =>
			events.sort(
				cmpByKey((event) => new Date(event.datetime_from).getTime())
			),
		[events]
	);

	return (
		<ul className={containerClassName}>
			{sortedEvents.map((event, index) => (
				<Event
					key={index}
					tags={tags}
					isExpanded={isExpanded}
					feature={feature}
					eventPredicates={eventPredicates}
					event={event}
					itemClassName={itemClassName}
					prefixClassName={prefixClassName}
				/>
			))}
		</ul>
	);
}
